import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Typography } from '@material-ui/core';

import {
  ASSET_TYPE,
  getAssetLabel,
  getAssetChannelLabel,
} from 'src/data/asset';
import {
  GENERATION_TOOL,
  getToolTitle,
  getToolDescription,
  isRewriteGenerationTool,
} from 'src/data/generationTool';
import { useStyles } from './useStyles';

export const VariationFormat = ({ className, assetType, generationTool }) => {
  const styles = useStyles();

  const toolTitle = getToolTitle(generationTool);
  const toolDescription = getToolDescription(generationTool);
  const isRewriteTool = isRewriteGenerationTool(generationTool);

  return (
    <div className={cx(styles.root, className)}>
      <Typography className={styles.title} component="span">
        {toolTitle || getAssetChannelLabel(assetType)}
      </Typography>{' '}
      <Typography className={styles.description} component="span">
        {/* Do not show default assetLabel for rewrite use case */}
        {toolDescription || (!isRewriteTool && getAssetLabel(assetType))}
      </Typography>
    </div>
  );
};

VariationFormat.propTypes = {
  className: PropTypes.string,
  assetType: PropTypes.oneOf(Object.values(ASSET_TYPE)),
  generationTool: PropTypes.oneOf(Object.values(GENERATION_TOOL)),
};

VariationFormat.defaultProps = {
  className: null,
  assetType: null,
  generationTool: null,
};
